import React, { useCallback, useMemo, useState } from 'react'
import { shallowEqual, useDispatch, useSelector } from 'react-redux'

import { selectIsUserAuthenticated } from 'features/auth/selectors'
import { selectLocaleDict } from 'features/locale/selectors'
import { hideBalanceFromBonusNotify } from 'features/notifies/actions'
import { selectNotifies } from 'features/notifies/selectors'

import NotifyContainer from '../NotifyContainer/NotifyContainer'
import BalanceFromBonusPolling from './BalanceFromBonusPolling/BalanceFromBonusPolling'

const BalanceFromBonusNotify = () => {
  const dispatch = useDispatch()

  const isAuth = useSelector(selectIsUserAuthenticated, shallowEqual)
  const locale = useSelector(selectLocaleDict, shallowEqual).bonuses

  const updateBonusNotify = useSelector(selectNotifies, shallowEqual).balance

  const [temporarilyClosedNotify, setTemporarilyClosedNotify] = useState<number[]>([])

  const hideNotify = useCallback(
    (id: number) => {
      dispatch(hideBalanceFromBonusNotify(id))
    },
    [dispatch],
  )

  const temporarilyHideNotify = useCallback((id: number) => {
    setTemporarilyClosedNotify(prev => [...prev, id])
  }, [])

  const items = useMemo(
    () =>
      Object.keys(updateBonusNotify?.all || {})
        .filter(
          cashbackId =>
            !updateBonusNotify.hide?.includes(+cashbackId) && !temporarilyClosedNotify.includes(+cashbackId),
        )
        .map(cashback => {
          const currID = Number(cashback)
          const amount = updateBonusNotify.all[currID]?.amount
          const currency = updateBonusNotify.all[currID]?.amountCurrency

          return (
            <NotifyContainer
              key={currID}
              title={locale.yourBonus}
              value={String(amount)}
              currency={currency}
              callback={() => hideNotify(currID)}
              hideTemporarily={() => temporarilyHideNotify(currID)}
            />
          )
        }),
    [updateBonusNotify, hideNotify, temporarilyHideNotify, locale, temporarilyClosedNotify],
  )

  return isAuth ? (
    <>
      <BalanceFromBonusPolling />
      {items}
    </>
  ) : null
}

export default BalanceFromBonusNotify
